import { render, staticRenderFns } from "./TabCoursedetail.vue?vue&type=template&id=511ad31e"
import script from "../../../services/teacher/DetailCourseTab/tab-coursedetail.js?vue&type=script&lang=js&external"
export * from "../../../services/teacher/DetailCourseTab/tab-coursedetail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports